import React from "react";
import { Card, CardHeader, Typography } from "@mui/material";
import { HiOutlineClipboardDocumentList } from "react-icons/hi2";

const OperationHeader = () => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            العمليات
          </Typography>
        }
        avatar={<HiOutlineClipboardDocumentList size={20} />}
      />
    </Card>
  );
};

export default OperationHeader;
